import { render } from "./MechHiveProject.vue?vue&type=template&id=55be2b72"
const script = {}

import "./MechHiveProject.vue?vue&type=style&index=0&id=55be2b72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__